<template>
  <div class="canned-response-table">
    <b-form-input
      v-model="cannedResponseSelected"
      class="email-response--canned-responses"
      list="responses"
      placeholder="Canned responses"
      aria-label="Canned responses"
      autocomplete="off"
      @change="cannedResponseId($event, rowId)"
      :disabled="fieldDisabled"
    ></b-form-input>
    <datalist id="responses">
      <option v-for="response in responses" :key="response.id">
        {{ response.name }}
      </option>
    </datalist>
  </div>
</template>

<script>
import { disableByAssigned } from "@/mixins/infoEmail/validateQuote";
export default {
  name: "CannedResponseTable",
  props: {
    rowInfo: Object,
    infoUsername: String,
    responsesCanned: Object
  },
  data() {
    return {
      cannedResponseSelected: null,
      responses: null,
      cannedResponsesId: null,
      rowId: null,
      fieldDisabled: false,
      responseNames: null
    };
  },
  async created() {
    this.fieldDisabled = disableByAssigned(
      this.rowInfo,
      this.infoUsername,
      this.$route.path
    );
    this.rowId = this.rowInfo.id;
  },
  async beforeMount() {
    this.responses = this.responsesCanned.data;
    this.responseNames = this.responses.map(el => el.name);
  },
  watch: {
    cannedResponseSelected() {
      if (!this.responseNames.includes(this.cannedResponseSelected)) {
        this.$emit("cannedResponseId", {
          emailId: this.rowInfo.id,
          cannedResponsesId: null
        });
      }
    }
  },
  methods: {
    cannedResponseId(cannedResponseName, emailId) {
      let cannedResponseSelectedInfo = this.responses.find(
        element => element.name == cannedResponseName
      );
      if (cannedResponseSelectedInfo) {
        this.cannedResponsesId = cannedResponseSelectedInfo.id;
        this.$emit("cannedResponseId", {
          emailId: emailId,
          cannedResponsesId: this.cannedResponsesId
        });
      }
    }
  }
};
</script>
